module.exports = __webpack_public_path__ + "static/media/login-background.c3cf8e22.mp4";